import React, { useEffect, useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import "./Navbar.css";
import AutoCompleteSm from "./AutoCompleteSm";
import DialogoEnviarWhatsapp from "./DialogoEnviarWhatsapp";
import { useAuth } from "../Auth/AuthContext";
import DataService from "../IndexBD/DataService";
import GlobalFunctions from "../Services/GlobalFunctions";
import Swal from "sweetalert2";
import * as serviceWorkerRegistration from "../serviceWorkerRegistration";

function CustomNavbar(params) {
  const { user, logout } = useAuth();
  const glob = new GlobalFunctions();
  const [online, setOnline] = useState(false);

  useEffect(() => {
    if (glob.getCookie("online") != null) {
      if (glob.getCookie("online") == "true") {
        setOnline(true);
      } else {
        setOnline(false);
      }
    }
  }, []);

  function cambioOnline() {
    if (online) {
      glob.setCookie("online", false, 3600 * 60 * 24);
      setOnline(false);
    } else {
      setOnline(true);
      glob.setCookie("online", true, 3600 * 60 * 24);
    }
  }

  function enviarWhastapp() {
    document.getElementById("btnOpenModalEnviarWhatsapp").click();
    document.getElementById("btnToggleNavbar").click();
  }

  const borrarTodosLosDatos = async () => {
    try {
      await DataService.removeData("carteras");
      await DataService.removeData("clientes");
      await DataService.removeData("asesor");
      glob.setCookie("cartera_prede", "", 3600 * 24 * 30);
    } catch (err) {}
  };

  function confirmarCerrarSesion() {
    document.getElementById("btnToggleNavbar").click();
    Swal.fire({
      title: "¿Cerrar sesión? Se borrarán todos los datos guardados.",
      showCancelButton: true,
      confirmButtonColor: "green",
      confirmButtonText: "Confirmar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        cerrarSesion();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    });
  }

  function cerrarSesion() {
    document.getElementById("btnParamsLoading").click();
    borrarTodosLosDatos();
    document.getElementById("btnCerrarSesion").click();
    glob.setCookie("session", false, 3600 * 24 * 30);
  }

  function confirmarActualizarApp() {
    document.getElementById("btnToggleNavbar").click();
    Swal.fire({
      title:
        "¿Actualizar aplicación? Se borrarán todos los datos guardados y tendras que hacer login de nuevo.",
      showCancelButton: true,
      confirmButtonColor: "green",
      confirmButtonText: "Confirmar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        setTimeout(() => {
          borrarCache();
        }, 500);
      }
    });
  }

  function borrarCache() {
    if ("serviceWorker" in navigator) {
      // Desregistrar el Service Worker
      serviceWorkerRegistration.unregister();
      // Luego, también limpiamos las cachés del navegador por si acaso,
      // aunque el desregistro del SW suele encargarse de la suya.
      if ("caches" in window) {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
      }
      // Finalmente, recargar la página para que todo se cargue de nuevo sin SW
      // y para que un nuevo SW (si se registra automáticamente) tenga un comienzo limpio.
      setTimeout(() => {
        // Pequeño retardo para dar tiempo al desregistro
        window.location.reload(true);
      }, 500);
    } else if ("caches" in window) {
      // Si no hay soporte para Service Worker, solo borra cachés directamente
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
        window.location.href = process.env.REACT_APP_MY_URL;
      });
    } else {
      window.location.href = process.env.REACT_APP_MY_URL;
    }
  }

  return (
    <Navbar expand="sm" className="custom-navbar">
      <Container>
        <Navbar.Brand
          onClick={() => params.goLista("navbar")}
          className="navbar-brand-custom"
          id="linkGoLista"
        >
          {user ? "Hola " + user.name + "!" : "Listas-cartera"}
        </Navbar.Brand>
        <Navbar.Toggle id="btnToggleNavbar" aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              onClick={() => params.goLista("navbar")}
              className="nav-link-custom"
            >
              Lista
            </Nav.Link>
            <Nav.Link
              onClick={() => enviarWhastapp()}
              className="nav-link-custom"
            >
              Enviar whatsapp
            </Nav.Link>
            <Nav.Link
              onClick={params.hacerSolicitud}
              className="nav-link-custom"
            >
              Hacer solicitud crédito
            </Nav.Link>
            <Nav.Link
              onClick={() => params.confirmarTraerDatos("navbar")}
              className="nav-link-custom"
            >
              Actualizar clientes
            </Nav.Link>
            <Nav.Link
              onClick={() => params.cotizar("navbar")}
              className="nav-link-custom"
            >
              Cotizar crédito
            </Nav.Link>
            <Nav.Link
              onClick={confirmarActualizarApp}
              className="nav-link-custom"
            >
              Actualizar aplicación
            </Nav.Link>
            <Nav.Link
              onClick={() => confirmarCerrarSesion()}
              className="nav-link-custom"
            >
              Cerrar sesión
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
        <AutoCompleteSm
          confirmarFetchPrestamos={params.confirmarFetchPrestamos}
          clientes={params.clientes}
          validarDetalleCliente={params.validarDetalleCliente}
        ></AutoCompleteSm>
        <div
          style={{ marginLeft: "0.6em", color: online ? "white" : "black" }}
          className="form-check form-switch "
        >
          <input
            style={{ backgroundColor: online ? "green" : "gray" }}
            className="form-check-input"
            type="checkbox"
            id="flexSwitchCheckDefault"
            checked={online}
            onChange={cambioOnline}
          />
          <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
            {online ? "Online" : "offline"}
          </label>
        </div>
      </Container>
      <DialogoEnviarWhatsapp></DialogoEnviarWhatsapp>
      <button
        id="btnCerrarSesion"
        onClick={logout}
        style={{ display: "none" }}
      ></button>
      <button
        id="btnParamsLoading"
        onClick={params.loading}
        style={{ display: "none" }}
      ></button>
    </Navbar>
  );
}

export default CustomNavbar;
